import React from "react";
import "./ServiceApproach.css";
import { useParams } from "react-router-dom";

const allApproachRecords = {
  "ai-voice-assistant-ai-agent": {
    title: `Transform Your Business <br /> with Custom AI Solutions`,
    description:
      "Unlock the full potential of your business with our bespoke AI-powered software development services. Specializing in web, mobile, chatbot, and desktop applications, we craft tailored solutions designed to enhance productivity, streamline operations, and foster collaboration within your organization. Our expert team ensures seamless integration with your existing systems, minimizing disruption and maximizing efficiency from day one.",
    steps: [
      {
        number: "1",
        title: "Tailored Development Process",
        description:
          "Our approach is centered around understanding your unique business needs and delivering custom AI solutions that integrate perfectly into your existing operations. This enables you to benefit from enhanced functionalities without the complexities typically associated with new software implementation.",
      },
      {
        number: "2",
        title: "Continuous Support and Maintenance",
        description:
          "We provide round-the-clock support and maintenance, ensuring that any issues are addressed swiftly and your custom solutions continue to perform optimally, thereby guaranteeing uninterrupted business operations and enhanced user satisfaction.",
      },
    ],
  },
  "web-development": {
    title: "Transform Your Business <br /> with Custom Web Solutions",
    description:
      "Unlock robust web strategies that drive growth and establish your online presence with cutting-edge designs and scalable solutions tailored for your market.",
    steps: [
      {
        number: "1",
        title: "Custom Website Design",
        description:
          "Our design process begins with understanding your brand, ensuring your website is unique, engaging, and tailored to your audience.",
      },
      {
        number: "2",
        title: "Ongoing Support and Enhancement",
        description:
          "From seamless integrations to regular updates, we ensure your website remains ahead of the curve, both in aesthetics and functionality.",
      },
    ],
  },
  "mobile-app-development-android-ios-hybrid-apps": {
    title: "Mobile Innovation at Your <br /> Fingertips",
    description:
      "Experience the future of mobile technology with our custom app solutions that are designed to offer the best performance and user experience across all platforms.",
    steps: [
      {
        number: "1",
        title: "User-Centered Design",
        description:
          "Our process begins with meticulous research to design an app that resonates with your target audience.",
      },
      {
        number: "2",
        title: "End-to-End Development & Support",
        description:
          "From development to deployment and beyond, we provide comprehensive solutions to keep your app performing at its best.",
      },
    ],
  },
  "machine-learning-deep-learning-solutions": {
    title: "Harness the Future with <br /> AI & ML",
    description:
      "Leverage our expertise in machine learning and deep learning to transform data into actionable insights, streamline operations, and drive business growth with intelligent automation.",
    steps: [
      {
        number: "1",
        title: "Data-Driven Insights",
        description:
          "Our process utilizes advanced analytics to turn your data into powerful insights for better decision making.",
      },
      {
        number: "2",
        title: "Seamless AI Integration",
        description:
          "We tailor custom AI integrations that adapt to your business processes, ensuring smooth deployment and operation.",
      },
    ],
  },
};

const defaultApproach = Object.values(allApproachRecords)[0];

export default function ServiceApproach() {
  const { slug } = useParams();
  const data = allApproachRecords[slug] || defaultApproach;
  return (
    <div className="service-approach">
      <div className="container-fluid">
        <div className="service-approach-wrap">
          <div className="service-approach-left">
            <h1 dangerouslySetInnerHTML={{ __html: data.title }} />
            <p>{data.description}</p>
          </div>

          <div className="service-approach-right">
            {data?.steps?.map((step, index) => (
              <div className="process-step" key={index}>
                <div className="step-header">
                  <div className="step-number-container">
                    <div className="step-number-shape">
                      <span>{step.number}</span>
                    </div>
                  </div>
                  <div className="step-title">{step.title}</div>
                </div>
                <p className="step-description">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
